"use client";

import { sendTrackingEvent } from "@/lib/tracking/send-tracking-event";
import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

type TrackingEventProps = {
  eventName: string;
  // eslint-disable-next-line @typescript-eslint/no-wrapper-object-types
  eventProps: Object;
};
export default function TrackingEvent({
  eventName,
  eventProps,
}: TrackingEventProps) {
  const pathname = usePathname();
  const hasSentRef = useRef(false);

  useEffect(() => {
    if (hasSentRef.current) {
      return;
    }

    sendTrackingEvent({
      eventName,
      page: pathname,
      eventProps: eventProps as Record<string, unknown>,
    });
    hasSentRef.current = true;
  }, [eventName, eventProps, pathname]);

  return <></>;
}

export function useTrackEvent() {
  const pathname = usePathname();

  return (eventName: string, eventProps: Record<string, unknown>) => {
    sendTrackingEvent({
      eventName,
      page: pathname,
      eventProps,
    });
  };
}
